import { Flex } from '@mantine/core'
import styled from 'styled-components'

export const ChartStyled = styled(Flex)`
  width: 120px;
  height: 32px;
`
